const PREFERENCES_KEY = {
    OPENING_BEHAVIOR: 'Menu Opening Behavior',
    NOTIFICATION_SOUND_ENABLED: 'Notification Sound Enabled',
};

export default PREFERENCES_KEY;
